import PropTypes from 'prop-types'
import React, {useState, useEffect} from 'react'
import {Box, SimpleGrid, Link, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {icon} from '../../icons'

const FooterContent = ({id, content, styles, onClick, setModalContent}) => {
    const [items, setItems] = useState([])

    const handleClick = (event) => {
        if (setModalContent) {
            event.preventDefault()
            const dataContent = event.target.getAttribute('data-content')
            const modalContentId = dataContent?.split('-')[1]
            setModalContent(`content-${modalContentId}`)
            onClick()
        }
    }

    useEffect(() => {
        if (content && content !== '') {
            const doc = new DOMParser().parseFromString(content, 'text/html')
            const elements = doc.querySelectorAll('ul li')

            const parsedItems = Array.from(elements).map((element) => {
                const anchor = element.querySelector('a')
                const icon = element.querySelector('.laur') || element.querySelector('.fa')

                return {
                    link: {
                        href: anchor?.getAttribute('href') || undefined,
                        target: anchor?.getAttribute('target') || undefined
                    },
                    htmlText: element.querySelector('.name')?.innerHTML || '',
                    text: anchor?.textContent || element.textContent || '',
                    icon: icon?.className?.split(' ')[1] || ''
                }
            })

            setItems(parsedItems)
        }
    }, [content])

    return (
        <Box {...styles.box} data-test-id={id}>
            <SimpleGrid {...styles.grid}>
                {items &&
                    items.map((item, index) => {
                        const IconComponent = icon(item.icon)

                        return (
                            <Link
                                key={`item-${index}`}
                                href={item?.link?.href}
                                target={item?.link?.target}
                                onClick={handleClick}
                                data-content={item?.icon}
                                {...styles?.link}
                            >
                                {item?.icon && (
                                    <IconComponent pointerEvents={'none'} {...styles?.icon} />
                                )}
                                {item?.htmlText ? (
                                    <Box
                                        {...styles?.htmlText}
                                        dangerouslySetInnerHTML={{__html: item.htmlText}}
                                    />
                                ) : (
                                    <Text pointerEvents="none" {...styles?.text}>
                                        {item?.text}
                                    </Text>
                                )}
                            </Link>
                        )
                    })}
            </SimpleGrid>
        </Box>
    )
}

FooterContent.propTypes = {
    id: PropTypes.string,
    styles: PropTypes.object,
    content: PropTypes.string,
    onClick: PropTypes.func,
    setModalContent: PropTypes.func
}

export default FooterContent
